import { Alert, AlertList, AlertWrapper } from "../../common-ui/components/feedback/Alert";
import { usePageErrors } from "./PageErrorContext";
import { useTranslation } from "react-i18next";

export const DisplayErrors = () => {
  const { formErrors } = usePageErrors();
  const { t } = useTranslation();

  if (!formErrors || formErrors.globalErrorMessages.length === 0) {
    return null;
  }

  return (
    <AlertWrapper>
      <Alert
        type="error"
        message={t("error.list.title")}
        withBackground
        description={
          <AlertList>
            {formErrors.globalErrorMessages.map((msg, index) => (
              <li key={index}>{t(msg)}</li>
            ))}
          </AlertList>
        }
      />
    </AlertWrapper>
  );
};